import {statusBadgeClass, statusIconClass, statusTextClass} from '@/utils/statusColors';

export type EnvelopeStatusString =
    | 'init'
    | 'pending'
    | 'in_progress'
    | 'reset'
    | 'voided'
    | 'completed'
    | 'declined'
    | (string & {});

export function envelopeStatusLabel(status?: EnvelopeStatusString | null): string {
    switch (status) {
        case 'init':
            return 'Pending';
        case 'pending':
            return 'Pending';
        case 'in_progress':
            return 'In Progress';
        case 'reset':
            return 'Reset';
        case 'voided':
            return 'Voided';
        case 'declined':
            return 'Declined';
        case 'expired':
            return 'Expired';
        case 'completed':
            return 'Completed';
        default:
            return status || 'Unknown';
    }
}

export function envelopeStatusTextClass(status?: EnvelopeStatusString | null): string {
    return `auth-label ${statusTextClass(status)}`;
}

export function envelopeStatusBadgeClass(status?: EnvelopeStatusString | null): string {
    return statusBadgeClass(status);
}

export function envelopeStatusIconClass(status?: EnvelopeStatusString | null): string {
    return statusIconClass(status);
}
